<template>
    <router-view />
</template>

<script lang="ts" src="./App.ts"></script>
